var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      disabledSave: _vm.disabled,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "50%",
      textButtonSave: "Salvar Cenário",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            autofocus: "",
                            dense: "",
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-dynamic-division-type", {
                          attrs: {
                            model: _vm.model.dynamic_division_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.dynamic_division_type_id,
                            label: "Origem Limite de Alunos",
                            dense: "",
                            "show-description": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "dynamic_division_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-shift", {
                          attrs: {
                            model: _vm.model.shifts,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.shifts,
                            label: "Turno*",
                            dense: "",
                            multiple: "",
                            "select-all": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "shifts", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-campus", {
                          attrs: {
                            model: _vm.model.campuses,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.campuses,
                            label: "Campus*",
                            multiple: "",
                            dense: "",
                            "select-all": "",
                            "only-active": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "campuses", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-course", {
                          attrs: {
                            model: _vm.model.courses,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.courses,
                            label: "Curso",
                            multiple: "",
                            dense: "",
                            "select-all": "",
                            "only-active": "",
                            shifts: _vm.model.shifts,
                            "campus-id": _vm.model.campuses
                              ? _vm.model.campuses.map((c) => c.id).join(",")
                              : null,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "courses", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Considerar previsão de alunos ao invés do número de alunos confirmados",
                            inset: "",
                            label: "Previsão de Alunos",
                          },
                          model: {
                            value: _vm.model.consider_students_forecast,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "consider_students_forecast",
                                $$v
                              )
                            },
                            expression: "model.consider_students_forecast",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            disabled: _vm.model.dynamic_division_type_id != 6,
                            "error-messages": _vm.errors.students_limit,
                            label: "Limite Padrão",
                          },
                          model: {
                            value: _vm.model.students_limit,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "students_limit", $$v)
                            },
                            expression: "model.students_limit",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Desconsiderar turmas que possui junção",
                            inset: "",
                            label: "Turma sem junção",
                          },
                          model: {
                            value: _vm.model.only_grid_not_join,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "only_grid_not_join", $$v)
                            },
                            expression: "model.only_grid_not_join",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper": "Equalizar número de alunos",
                            inset: "",
                            label: "Equalizar alunos",
                          },
                          model: {
                            value: _vm.model.equalize_students,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "equalize_students", $$v)
                            },
                            expression: "model.equalize_students",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-select", {
                          attrs: {
                            disabled: ![2, 3].includes(
                              _vm.model.dynamic_division_type_id
                            ),
                            items: _vm.calculationTypes,
                            label: "Cálculo da Capacidade",
                            "item-value": "id",
                            "item-text": "name",
                          },
                          model: {
                            value: _vm.model.calculation_type_capacity,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "calculation_type_capacity",
                                $$v
                              )
                            },
                            expression: "model.calculation_type_capacity",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }